import style from './cute.module.scss';

export const CuteLoader = () => {
  return <div className={style.loader}></div>;
};
